import React from 'react';
import PropTypes from 'prop-types';

const TruckIcon = ({ className, size = 'md', width, height }) => {
  const sizes = {
    sm: { width: '14.67', height: '12' },
    md: { width: '24', height: '20' },
  };

  return (
    <svg
      width={width ?? sizes[size].width}
      height={height ?? sizes[size].height}
      viewBox='0 0 24 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className={className}
        d='M16 14V1H1V14H16ZM16 14H23V9L20 6H16V14ZM8 16.5C8 17.8807 6.88071 19 5.5 19C4.11929 19 3 17.8807 3 16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5ZM21 16.5C21 17.8807 19.8807 19 18.5 19C17.1193 19 16 17.8807 16 16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5Z'
        stroke='#242546'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

TruckIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default TruckIcon;
